module.exports = __webpack_public_path__ + "media/images/product_lines/car/h1-91d9a085431f04c52fc402a81dd3e93f.svg";